import type { StatementDataColumnConfiguration } from "../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import type { FormulaReferenceField } from "../../common/fields/custom-field/utilities/customFormulaParser.ts";
import StatementFormulaDialog from "../formulas/StatementFormulaDialog.tsx";
import type { StatementFormula } from "../utils/statementFormulas.ts";

interface Props {
  column: StatementDataColumnConfiguration;
  isNew: boolean;
  referableFields: FormulaReferenceField[];
  onClose: () => void;
}

const FormulaColumnDialog = ({ column, isNew, referableFields, onClose }: Props) => {
  const dispatch = useAppDispatch();

  const handleApply = (formula: StatementFormula) => {
    if (isNew) {
      dispatch(createFinancialStatementAction("addDataColumn", { ...column, ...formula }));
    } else {
      dispatch(createFinancialStatementAction("updateDataColumn", { guid: column.guid, changes: formula }));
    }
    onClose();
  };

  return (
    <StatementFormulaDialog
      source={column}
      referableFields={referableFields}
      allowGrandTotal={false}
      onClose={onClose}
      onApply={handleApply}
    />
  );
};

export default FormulaColumnDialog;
